import React, { FunctionComponent } from "react";
import { Table } from "evergreen-ui";
import { AbstractTableBodyCellRenderer } from "./AbstractTableBodyCellRenderer";
import { genericMemo } from "../../../GenericMemo";

export class TableReadOnlyCellRenderer<T> extends AbstractTableBodyCellRenderer<T> {
    protected getMemoizedComponent(): FunctionComponent {
        const {cellValue, columnConfig: {textAlign}} = this.input;
        const textProps = textAlign ? { style: { textAlign } } : undefined;
        return genericMemo(() => (
            <Table.TextCell className={"jc-body-cell read-only"} textProps={textProps}>
                {cellValue}
            </Table.TextCell>
        ));
    }
}
